import styled from 'styled-components'
import { color } from 'core/theme'

export const StyledLink = styled.a`
  color: ${color.primary.variant.dark};
`
